<div class="container-box">
  <app-table-header tableTitle="Provvigione venditori" (btnUpdateClick)="loadCommissions()">
    <app-button-new-commission action-button></app-button-new-commission>
  </app-table-header>
  <div class="table-container">
    <ng2-smart-table
      id="commissionsTable"
      class="table-content"
      [settings]="settings"
      [source]="source"
    ></ng2-smart-table>
  </div>
</div>
